import i18next from '@bonanza-social/i18n';
import en from './en.json';
import fr from './fr.json';

i18next.addResources('en', 'rewards', en);
i18next.addResources('fr', 'rewards', fr);

declare global {
  interface RegisteredLocales {
    rewards: typeof en;
  }
}
